export const getAcademieById = (academies, academieId) => {
  const academie = Array.isArray(academies)
      && academies.find(academie => academie.id === academieId);
  return academie;
};

export const setAcademieToEdit = (academies, academie) => {
  const academieFound = Array.isArray(academies)
      && academie;
  const academieToEdit = {
    ...academieFound,
    nombre: academie.nombre,
    plataforma: academie.plataforma,
    publica: academie.publica,
  }
  return academieToEdit;
};